// Adult Anime Page - Dedicated adult content page
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Stack, Button, Card, CardContent, Chip } from '@mui/material';
import { motion } from 'framer-motion';
import { Warning, Lock, LockOpen } from '@mui/icons-material';
import { useSettings } from '../../hooks/useSettings';

export default function Adult() {
  const navigate = useNavigate();
  const { settings, setSettings } = useSettings();

  return (
    <Box sx={{ width: '100%', maxWidth: 700, mx: 'auto', textAlign: 'center' }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
      >
        <Box sx={{ mb: 4 }}>
          <Warning sx={{ fontSize: 80, color: '#F97316', mb: 2 }} />
          <Typography variant="h3" fontWeight={900} sx={{ mb: 1 }}>
            Adult Content
          </Typography>
          <Typography variant="body1" color="text.secondary">
            This section contains 18+ anime and content. Please confirm your age before proceeding.
          </Typography>
        </Box>

        {!settings.showAdultContent ? (
          <Card sx={{ p: 4 }}>
            <Lock sx={{ fontSize: 48, color: 'var(--anime-token-text-tertiary)', mb: 2 }} />
            <Typography variant="h5" fontWeight={700} sx={{ mb: 1 }}>
              Content Locked
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Enable adult content in your settings to browse 18+ anime.
            </Typography>
            <Button
              variant="gradient"
              size="large"
              onClick={() => navigate('/settings')}
            >
              Go to Settings
            </Button>
          </Card>
        ) : (
          <Stack spacing={2} alignItems="center">
            <Card sx={{ p: 4, textAlign: 'center', width: '100%' }}>
              <LockOpen sx={{ fontSize: 48, color: '#F97316', mb: 2 }} />
              <Typography variant="h5" fontWeight={700} sx={{ mb: 1 }}>
                You have access to adult content
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                Adult anime will now appear throughout the site. You can disable this anytime in Settings.
              </Typography>
              <Stack direction="row" spacing={2} justifyContent="center">
                <Button
                  variant="gradient"
                  size="large"
                  onClick={() => navigate('/browse?type=TV')}
                >
                  Browse Anime
                </Button>
                <Button
                  variant="outlined"
                  size="large"
                  onClick={() => navigate('/settings')}
                >
                  Settings
                </Button>
              </Stack>
            </Card>
          </Stack>
        )}
      </motion.div>
    </Box>
  );
}